"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeTransitionSpeed = void 0;
const computeTransitionSpeed = (speed) => {
    switch (speed) {
        case 'Fast':
            return 500;
        case 'Slow':
            return 900;
        case 'Regular':
            return 700;
        default:
            return 700;
    }
};
exports.computeTransitionSpeed = computeTransitionSpeed;
const computeTransition = ({ animationValue, transition, dimensions, }) => {
    switch (transition) {
        case 'FadeIn':
            return {
                opacity: animationValue,
            };
        case 'SlideTop':
            return {
                transform: [
                    {
                        translateY: animationValue.interpolate({
                            inputRange: [0, 1],
                            outputRange: [dimensions.height, 0],
                        }),
                    },
                ],
            };
        case 'SlideBottom':
            return {
                transform: [
                    {
                        translateY: animationValue.interpolate({
                            inputRange: [0, 1],
                            outputRange: [-dimensions.height, 0],
                        }),
                    },
                ],
            };
        case 'SlideRight':
            return {
                transform: [
                    {
                        translateX: animationValue.interpolate({
                            inputRange: [0, 1],
                            outputRange: [-dimensions.width, 0],
                        }),
                    },
                ],
            };
        case 'SlideLeft':
            return {
                transform: [
                    {
                        translateX: animationValue.interpolate({
                            inputRange: [0, 1],
                            outputRange: [dimensions.width, 0],
                        }),
                    },
                ],
            };
        case 'FadeOut':
            return {
                opacity: animationValue.interpolate({
                    inputRange: [0, 1],
                    outputRange: [1, 0],
                }),
            };
        case 'SlideTopOut':
            return {
                transform: [
                    {
                        translateY: animationValue.interpolate({
                            inputRange: [0, 1],
                            outputRange: [0, dimensions.height],
                        }),
                    },
                ],
            };
        case 'SlideRightOut':
            return {
                transform: [
                    {
                        translateX: animationValue.interpolate({
                            inputRange: [0, 1],
                            outputRange: [0, -dimensions.width],
                        }),
                    },
                ],
            };
        case 'SlideBottomOut':
            return {
                transform: [
                    {
                        translateY: animationValue.interpolate({
                            inputRange: [0, 1],
                            outputRange: [0, -dimensions.height],
                        }),
                    },
                ],
            };
        case 'SlideLeftOut':
            return {
                transform: [
                    {
                        translateX: animationValue.interpolate({
                            inputRange: [0, 1],
                            outputRange: [0, dimensions.width],
                        }),
                    },
                ],
            };
        default:
            return {};
    }
};
exports.default = computeTransition;
